import React, { useState, useEffect, useCallback } from 'react';

const useWindowWidth = () => {
  const [w, setW] = useState(window.innerWidth);
  useEffect(() => {
    const h = () => setW(window.innerWidth);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  return w;
};
import { CASE_CATEGORIES } from '../constants/caseCategories';
import { displayLocation } from '../utils/locationUtils';
import { translatePA } from '../utils/practiceAreaUtils';

const getParentCategories = (practiceAreas) => {
  const parents = new Set();
  for (const area of practiceAreas) {
    const parent = CASE_CATEGORIES.find(cat => cat.subs.includes(area) || cat.label === area);
    if (parent) parents.add(parent.label);
  }
  return [...parents];
};

const SERVER_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace('/api', '');

const REGION_LABELS_RU = {
  tashkent_city:'Ташкент (город)',tashkent:'Ташкентская область',
  andijan:'Андижанская область',fergana:'Ферганская область',
  namangan:'Наманганская область',samarkand:'Самаркандская область',
  bukhara:'Бухарская область',navoi:'Навоийская область',
  kashkadarya:'Кашкадарьинская область',surkhandarya:'Сурхандарьинская область',
  jizzakh:'Джизакская область',sirdarya:'Сырдарьинская область',
  khorezm:'Хорезмская область',karakalpakstan:'Республика Каракалпакстан',
};
const REGION_KEY_BY_RU = Object.fromEntries(Object.entries(REGION_LABELS_RU).map(([k,v])=>[v,k]));
import { useParams, Link, useSearchParams, useNavigate } from 'react-router-dom';
import { attorneyAPI, ratingAPI, savedAttorneyAPI, getErrorKey } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { SaveToggle, TierBadge } from '../components/common/AttorneyCard';
import StarRating from '../components/common/StarRating';

const styles = {
  container: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: '2rem',
  },
  backLink: {
    display: 'inline-flex',
    alignItems: 'center',
    color: '#3182ce',
    textDecoration: 'none',
    marginBottom: '1.5rem',
    fontSize: '0.9rem',
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '2rem',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  header: {
    display: 'flex',
    gap: '2rem',
    marginBottom: '2rem',
    paddingBottom: '2rem',
    borderBottom: '1px solid #e2e8f0',
  },
  avatar: {
    width: '140px',
    height: '170px',
    borderRadius: '10px',
    backgroundColor: '#e2e8f0',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '3rem',
    color: '#a0aec0',
    flexShrink: 0,
  },
  headerInfo: {
    flex: 1,
  },
  name: {
    fontSize: 'clamp(1.2rem, 4vw, 2rem)',
    fontWeight: '700',
    color: '#1a365d',
    marginBottom: '0.5rem',
    wordBreak: 'break-word',
  },
  location: {
    color: '#718096',
    fontSize: 'clamp(0.85rem, 3vw, 1.1rem)',
    marginBottom: '0.5rem',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  },
  rate: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: '#38a169',
  },
  barNumber: {
    fontSize: '0.88rem',
    color: '#718096',
    marginTop: '0.5rem',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  },
  section: {
    marginBottom: '2rem',
  },
  sectionTitle: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: '#1a365d',
    marginBottom: '1rem',
  },
  practiceAreas: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.75rem',
  },
  tag: {
    backgroundColor: '#ebf8ff',
    color: '#2b6cb0',
    padding: '0.5rem 1rem',
    borderRadius: '20px',
    fontSize: '0.9rem',
    fontWeight: '500',
  },
  bio: {
    color: '#4a5568',
    lineHeight: '1.7',
    fontSize: '1rem',
  },
  contactSection: {
    backgroundColor: '#f7fafc',
    borderRadius: '8px',
    padding: '1.5rem',
    marginTop: '2rem',
  },
  contactButton: {
    backgroundColor: '#3182ce',
    color: 'white',
    padding: '0.875rem 2rem',
    border: 'none',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    marginRight: '1rem',
    textDecoration: 'none',
    display: 'inline-block',
  },
  secondaryButton: {
    backgroundColor: 'white',
    color: '#3182ce',
    padding: '0.875rem 2rem',
    border: '2px solid #3182ce',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
  },
  loading: {
    textAlign: 'center',
    padding: '3rem',
    color: '#718096',
  },
  error: {
    textAlign: 'center',
    padding: '3rem',
    color: '#c53030',
  },
  selectButton: {
    backgroundColor: '#38a169',
    color: 'white',
    padding: '0.875rem 2rem',
    border: 'none',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    marginRight: '1rem',
    width: '100%',
    marginBottom: '1rem',
  },
  selectSection: {
    backgroundColor: '#c6f6d5',
    borderRadius: '8px',
    padding: '1.5rem',
    marginBottom: '1.5rem',
    border: '2px solid #38a169',
  },
  successMessage: {
    backgroundColor: '#c6f6d5',
    color: '#276749',
    padding: '1rem',
    borderRadius: '8px',
    textAlign: 'center',
    marginBottom: '1rem',
  },
  errorMessage: {
    backgroundColor: '#fed7d7',
    color: '#c53030',
    padding: '1rem',
    borderRadius: '8px',
    textAlign: 'center',
    marginBottom: '1rem',
  },
};

const RatingInfoPopup = ({ onClose }) => {
  const { t } = useLanguage();
  return (
  <div style={{
    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
  }} onClick={onClose}>
    <div style={{
      backgroundColor: 'white', borderRadius: '14px', padding: '1.75rem',
      width: '460px', maxWidth: '92vw', boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
    }} onClick={e => e.stopPropagation()}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#1a365d', fontWeight: '700' }}>{t('findAttorney.ratingInfoTitle')}</h3>
        <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.3rem', cursor: 'pointer', color: '#718096', lineHeight: 1 }}>×</button>
      </div>
      <p style={{ color: '#4a5568', fontSize: '0.92rem', lineHeight: '1.8', margin: '0 0 1.25rem' }}>
        {t('findAttorney.ratingInfoBody')}
      </p>
      <div style={{ backgroundColor: '#fff5f5', borderLeft: '3px solid #fc8181', borderRadius: '0 6px 6px 0', padding: '0.9rem 1rem' }}>
        <p style={{ color: '#742a2a', fontSize: '0.85rem', fontWeight: '700', margin: '0 0 0.4rem' }}>{t('findAttorney.ratingDisclaimer')}</p>
        <p style={{ color: '#742a2a', fontSize: '0.85rem', lineHeight: '1.65', margin: 0 }}>
          {t('findAttorney.ratingDisclaimerText')}
        </p>
      </div>
    </div>
  </div>
  );
};

const RatingInfoIcon = ({ onClick }) => (
  <button onClick={e => { e.preventDefault(); e.stopPropagation(); onClick(); }} style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: '15px', height: '15px', borderRadius: '50%',
    backgroundColor: '#3182ce', color: 'white',
    border: 'none', cursor: 'pointer', fontSize: '10px', fontWeight: '700',
    fontStyle: 'italic', flexShrink: 0, lineHeight: 1,
    verticalAlign: 'middle', marginLeft: '4px',
  }}>i</button>
);

const StarRatingPopup = ({ onClose, onSubmit, submitting }) => {
  const [selected, setSelected] = useState(null);
  const [hovered, setHovered] = useState(null);
  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
    }} onClick={onClose}>
      <div style={{
        backgroundColor: 'white', borderRadius: '14px', padding: '2rem',
        width: '340px', boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
      }} onClick={e => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 0.5rem', fontSize: '1.15rem', color: '#1a365d' }}>Адвокатга баҳо беринг</h3>
        <p style={{ margin: '0 0 1.4rem', fontSize: '0.9rem', color: '#718096' }}>1 дан 5 гача юлдуз танланг (бир марта)</p>
        <div style={{ display: 'flex', gap: '0.4rem', marginBottom: '1.5rem', justifyContent: 'center' }}>
          {[1, 2, 3, 4, 5].map(s => (
            <button
              key={s}
              onClick={() => setSelected(s)}
              onMouseEnter={() => setHovered(s)}
              onMouseLeave={() => setHovered(null)}
              style={{
                background: 'none', border: 'none', cursor: 'pointer', padding: '0.1rem',
                fontSize: '2.1rem', lineHeight: 1,
                color: (hovered ?? selected) >= s ? '#f6ad55' : '#e2e8f0',
              }}
            >★</button>
          ))}
        </div>
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button onClick={onClose} style={{
            flex: 1, padding: '0.7rem', border: '1px solid #e2e8f0', borderRadius: '8px',
            backgroundColor: 'white', cursor: 'pointer', fontSize: '0.95rem', color: '#4a5568',
          }}>Бекор қилиш</button>
          <button
            onClick={() => selected !== null && onSubmit(selected)}
            disabled={selected === null || submitting}
            style={{
              flex: 1, padding: '0.7rem', border: 'none', borderRadius: '8px',
              backgroundColor: selected !== null ? '#3182ce' : '#cbd5e0',
              color: 'white', fontWeight: '600', fontSize: '0.95rem',
              cursor: selected !== null ? 'pointer' : 'not-allowed',
            }}
          >{submitting ? 'Юборилмоқда...' : 'Юбориш'}</button>
        </div>
      </div>
    </div>
  );
};

const AttorneyProfile = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isClient } = useAuth();
  const { t, language } = useLanguage();
  const isMobile = useWindowWidth() < 768;
  const [attorney, setAttorney] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selecting, setSelecting] = useState(false);
  const [selectSuccess, setSelectSuccess] = useState(false);
  const [selectError, setSelectError] = useState('');
  const [ratingAverage, setRatingAverage] = useState(0);
  const [ratingCount, setRatingCount] = useState(0);
  const [hasRated, setHasRated] = useState(false);
  const [showRatingPopup, setShowRatingPopup] = useState(false);
  const [showRatingInfo, setShowRatingInfo] = useState(false);
  const [submittingRating, setSubmittingRating] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  const caseId = searchParams.get('caseId');

  useEffect(() => {
    fetchAttorney();
    fetchRating();
  }, [id]);

  useEffect(() => {
    if (!isClient) return;
    savedAttorneyAPI.listIds().then(res => setIsSaved((res.data || []).includes(Number(id)))).catch(() => {});
  }, [isClient, id]);

  const fetchAttorney = async () => {
    try {
      const response = await attorneyAPI.getById(id);
      setAttorney(response.data);
    } catch (err) {
      setError(t(`errors.${getErrorKey(err) || 'attorneyNotFound'}`));
    } finally {
      setLoading(false);
    }
  };

  const fetchRating = async () => {
    try {
      const res = await ratingAPI.get(id);
      setRatingAverage(res.data.average);
      setRatingCount(res.data.count);
      setHasRated(res.data.hasRated);
    } catch {}
  };

  const handleSubmitRating = async (stars) => {
    setSubmittingRating(true);
    try {
      const res = await ratingAPI.submit(id, stars);
      setRatingAverage(res.data.average);
      setRatingCount(res.data.count);
      setHasRated(true);
      setShowRatingPopup(false);
    } catch (err) {
      console.error('[rating submit]', err.response?.data || err.message);
    }
    setSubmittingRating(false);
  };


  if (loading) {
    return <div style={styles.loading}>{t('common.loading')}</div>;
  }

  if (error) {
    return (
      <div style={styles.container}>
        <Link to="/find-attorney" style={styles.backLink}>
          &larr; {t('attorneyProfile.backToDirectory')}
        </Link>
        <div style={styles.error}>{error}</div>
      </div>
    );
  }

  return (
    <div style={{ ...styles.container, padding: isMobile ? '0.75rem' : '2rem' }}>
      {showRatingPopup && (
        <StarRatingPopup
          onClose={() => setShowRatingPopup(false)}
          onSubmit={handleSubmitRating}
          submitting={submittingRating}
        />
      )}
      {showRatingInfo && <RatingInfoPopup onClose={() => setShowRatingInfo(false)} />}
      {!caseId && (
        <Link to="/find-attorney" style={styles.backLink}>
          &larr; {t('attorneyProfile.backToDirectory')}
        </Link>
      )}

      <div style={{ ...styles.card, padding: isMobile ? '1.25rem' : '2rem' }}>
        <div style={{ ...styles.header, flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '1rem' : '2rem' }}>
          <div style={{ position: 'relative', width: isMobile ? '100px' : '140px', flexShrink: 0 }}>
            <div style={{ ...styles.avatar, width: isMobile ? '100px' : '140px', height: isMobile ? '120px' : '170px' }}>
              {attorney.profile_picture ? (
                <img
                  src={`${SERVER_URL}${attorney.profile_picture}`}
                  alt={attorney.full_name}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                </svg>
              )}
            </div>
            <TierBadge tier={attorney.tier} size={isMobile ? 100 : 140} />
          </div>
          <div style={{ ...styles.headerInfo, display: 'flex', flexDirection: 'column' }}>
            <h1 style={{ ...styles.name, margin: 0 }}>{attorney.full_name}</h1>
            {/* Rating block — directly below the name, same layout on mobile and desktop */}
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '0.6rem', marginTop: '0.4rem' }}>
              <StarRating
                average={ratingAverage}
                count={ratingCount}
                size={16}
                InfoIcon={<RatingInfoIcon onClick={() => setShowRatingInfo(true)} />}
              />
              {ratingCount === 0 && <RatingInfoIcon onClick={() => setShowRatingInfo(true)} />}
              {isClient && !hasRated && (
                <button onClick={() => setShowRatingPopup(true)} style={{
                  background: 'none', border: 'none', padding: 0,
                  color: '#3182ce', fontSize: '0.8rem', cursor: 'pointer',
                  textDecoration: 'underline',
                }}>Адвокатга баҳо беринг</button>
              )}
              {isClient && hasRated && (
                <span style={{ fontSize: '0.78rem', color: '#38a169' }}>✓ Баҳо берилди</span>
              )}
              <SaveToggle attorneyId={attorney.id} initialSaved={isSaved} compact />
            </div>
            <p style={styles.location}>
              {attorney.location ? displayLocation(attorney.location, t, language) : t('findAttorney.noLocationSpecified')}
            </p>
            {attorney.hourly_rate && (
              <p style={styles.rate}>${attorney.hourly_rate}/hour</p>
            )}
            {attorney.bar_number && (
              <p style={styles.barNumber}>{t('attorneyProfile.barNumber')}: {attorney.bar_number}</p>
            )}
            {attorney.phone && (
              <p style={{ ...styles.barNumber, marginTop: '0.25rem' }}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginRight: '0.3rem' }}>
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6.13 6.13l.98-.98a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                {attorney.phone}
              </p>
            )}
          </div>
        </div>

        {attorney.practice_areas?.length > 0 && (
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>{t('attorneyProfile.practiceAreas')}</h2>
            <div style={styles.practiceAreas}>
              {getParentCategories(attorney.practice_areas).map(parent => (
                <span key={parent} style={styles.tag}>{translatePA(parent, language)}</span>
              ))}
            </div>
          </div>
        )}

        {attorney.bio && (
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>{t('attorneyProfile.about')}</h2>
            <p style={styles.bio}>{attorney.bio}</p>
          </div>
        )}

        {attorney.articles?.length > 0 && (
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>Мақолалар</h2>
            <ul style={{ paddingLeft: '1.25rem', margin: 0 }}>
              {attorney.articles.map(ar => (
                <li key={ar.slug} style={{ marginBottom: '0.5rem' }}>
                  <a href={ar.url} style={{ color: '#3182ce', textDecoration: 'underline', fontSize: '0.95rem' }}>
                    {ar.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}

        {(attorney.published_articles?.length > 0 || attorney.legal_advice?.length > 0 || attorney.social_media_links?.length > 0
          || attorney.court_cases_count != null || attorney.workplace_before || attorney.specializations?.some(s => s?.trim())) && (
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>Мен ҳақимда тўлиқ маълумот</h2>

            {attorney.specializations?.some(s => s?.trim()) && (
              <p style={{ ...styles.bio, marginBottom: '0.5rem' }}>
                <strong>Мутахассислик йўналишлари:</strong> {attorney.specializations.filter(s => s?.trim()).join(', ')}
              </p>
            )}

            {attorney.court_cases_count != null && (
              <p style={{ ...styles.bio, marginBottom: '0.5rem' }}>
                <strong>Қатнашган суд ишлари сони (охирги 1 йилда):</strong> {attorney.court_cases_count}
              </p>
            )}

            {attorney.workplace_before && (
              <p style={{ ...styles.bio, marginBottom: '0.5rem' }}>
                <strong>Адвокат бўлишдан олдин иш жойи:</strong> {attorney.workplace_before}
              </p>
            )}

            {attorney.published_articles?.length > 0 && (
              <>
                <h3 style={{ fontSize: '0.95rem', color: '#1a365d', margin: '0.75rem 0 0.4rem' }}>Чоп қилган мақолалари</h3>
                <ul style={{ paddingLeft: '1.25rem', margin: 0 }}>
                  {attorney.published_articles.map((it, i) => (
                    <li key={i} style={{ marginBottom: '0.4rem' }}>
                      <a href={it.link} target="_blank" rel="noopener noreferrer" style={{ color: '#3182ce', textDecoration: 'underline', fontSize: '0.95rem' }}>
                        {it.title || it.link}
                      </a>
                    </li>
                  ))}
                </ul>
              </>
            )}

            {attorney.legal_advice?.length > 0 && (
              <>
                <h3 style={{ fontSize: '0.95rem', color: '#1a365d', margin: '0.75rem 0 0.4rem' }}>Ҳуқуқий маслаҳатлари, тушинтиришлари</h3>
                <ul style={{ paddingLeft: '1.25rem', margin: 0 }}>
                  {attorney.legal_advice.map((it, i) => (
                    <li key={i} style={{ marginBottom: '0.4rem' }}>
                      <a href={it.link} target="_blank" rel="noopener noreferrer" style={{ color: '#3182ce', textDecoration: 'underline', fontSize: '0.95rem' }}>
                        {it.title || it.link}
                      </a>
                    </li>
                  ))}
                </ul>
              </>
            )}

            {attorney.social_media_links?.length > 0 && (
              <>
                <h3 style={{ fontSize: '0.95rem', color: '#1a365d', margin: '0.75rem 0 0.4rem' }}>Ижтимоий тармоқдаги саҳифалари</h3>
                <ul style={{ paddingLeft: '1.25rem', margin: 0 }}>
                  {attorney.social_media_links.map((it, i) => (
                    <li key={i} style={{ marginBottom: '0.4rem' }}>
                      <a href={it.link} target="_blank" rel="noopener noreferrer" style={{ color: '#3182ce', textDecoration: 'underline', fontSize: '0.95rem' }}>
                        {it.title || it.link}
                      </a>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>
        )}

        {/* Contact this attorney CTA — always visible, independent of the case-select flow below */}
        <div style={{ backgroundColor: '#ebf8ff', borderRadius: '8px', padding: '1.5rem', marginBottom: '1.5rem', border: '2px solid #bee3f8', textAlign: 'center' }}>
          <h2 style={{ ...styles.sectionTitle, marginBottom: '1rem' }}>
            {attorney.full_name} хизматларидан фойдаланмоқчимисиз?
          </h2>
          <button
            onClick={() => navigate(`/contact/${attorney.id}`)}
            style={{
              backgroundColor: '#3182ce', color: 'white', padding: '0.875rem 2rem',
              border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: '600', cursor: 'pointer',
            }}
          >
            Адвокатга мурожаат қилиш
          </button>
        </div>

        {/* Select Attorney Section - Only shown when coming from a case */}
        {isClient && caseId && (
          <div style={styles.selectSection}>
            <h2 style={{ ...styles.sectionTitle, color: '#276749', marginBottom: '1rem' }}>
              {t('attorneyProfile.selectForCase').replace('{name}', attorney.full_name)}
            </h2>
            {selectSuccess ? (
              <div style={styles.successMessage}>
                {t('attorneyProfile.selectSuccess')}
              </div>
            ) : (
              <>
                {selectError && <div style={styles.errorMessage}>{selectError}</div>}
                <p style={{ color: '#276749', marginBottom: '1rem' }}>
                  {t('attorneyProfile.selectDescription')}
                </p>
                <button
                  style={styles.selectButton}
                  onClick={handleSelectAttorney}
                  disabled={selecting}
                >
                  {selecting ? t('attorneyProfile.selecting') : t('attorneyProfile.selectButton')}
                </button>
              </>
            )}
          </div>
        )}

      </div>
    </div>
  );
};

export default AttorneyProfile;
